import React from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <div className="container-fluid p-0 mb-5 wow fadeIn" data-wow-delay="0.1s">
      <div id="header-carousel" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img className="w-100" src="/img/carousel-3.png" alt="Image" />
            <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.5)', zIndex: 1 }}></div>
            <div className="carousel-caption" style={{ zIndex: 2 }}>
              <div className="container">
                <div className="row justify-content-start">
                  <div className="col-lg-7">
                    <h1 className="display-6 mb-5 animated slideInDown" style={{color: 'black'}}>Real, Natural Freshness That Builds Lasting Health</h1>
                    <Link to="/menu" className="btn btn-primary rounded-pill py-sm-3 px-sm-5">Menu</Link>
                    <a href="https://organique-juice-bar.square.site/" target="_blank" className="btn btn-secondary rounded-pill py-sm-3 px-sm-5 ms-3">Order Online</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*
        <button className="carousel-control-prev" type="button" data-bs-target="#header-carousel" data-bs-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#header-carousel" data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
        */}
      </div>
    </div>
  );
};

export default Hero;